import { config } from '../../../utils';

const fetchAllQrTemplates = async (superagentPostAsync) => {
  const url = config.town.back.urlPrefix
            + config.town.back.qr.template.list;
  // console.log(`Get all QR codes at ${url}`);

  const res = await superagentPostAsync(
    url,
    ['Content-Type', 'application/json'],
    {},
  );
  if (res.status !== 200) {
    throw new Error(`fetchAllQrTemplates status=${res.status}`);
  }

  return (res.body.rslt.data);
};

export default fetchAllQrTemplates;
